// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__2yz8w","modal":"Modal_modal__2u3HH","container":"Modal_container__1eNZH","close":"Modal_close__Skv1c"};